import { useTheme } from "@mui/material";

function Education4dpSnailGraphic() {
  const { palette } = useTheme();

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 441 118"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4179_67325)">
        <rect width="441" height="118" fill="url(#paint0_linear_4179_67325)" />
        <path
          d="M0 1C0 0.447718 0.447715 0 1 0H440C440.552 0 441 0.447715 441 1V111C441 111.552 440.552 118 440 118H1.00001C0.447726 118 0 111.552 0 111V1Z"
          fill="url(#paint1_linear_4179_67325)"
        />
        <path
          d="M221.146 52.3848C223.142 52.3848 225.118 52.8384 226.909 53.7119C228.706 54.5854 230.282 55.8563 231.521 57.4287C232.759 59.0012 233.627 60.8347 234.06 62.792C234.492 64.7492 234.479 66.7794 234.02 68.7305C233.56 70.6816 232.667 72.5034 231.407 74.0586C230.147 75.6138 228.553 76.8624 226.744 77.7109C224.936 78.5594 222.96 78.9856 220.964 78.958C219.301 78.935 217.66 78.5964 216.127 77.9648C214.167 77.4691 212.715 75.6873 212.715 73.5645C212.715 71.058 214.738 69.0255 217.233 69.0254C217.953 69.0254 218.633 69.1957 219.236 69.4961L219.262 69.4473C219.829 69.7327 220.454 69.8858 221.088 69.8945C221.722 69.9033 222.35 69.7677 222.925 69.498C223.5 69.2284 224.007 68.8321 224.407 68.3379C224.808 67.8437 225.091 67.2645 225.237 66.6445C225.383 66.0244 225.388 65.3789 225.25 64.7568C225.118 64.1348 224.837 63.5515 224.443 63.0518C224.05 62.5521 223.548 62.1487 222.978 61.8711C222.406 61.5935 221.78 61.4492 221.146 61.4492V52.3848Z"
          fill="url(#paint2_linear_4179_67325)"
        />
        <path
          d="M221.218 40.2822C224.756 40.2822 228.257 41.0236 231.494 42.459C234.731 43.8944 237.635 45.992 240.02 48.6182C242.404 51.2443 244.216 54.3414 245.342 57.7109C246.467 61.0806 246.881 64.6494 246.556 68.1885C246.23 71.7277 245.174 75.1607 243.453 78.2666C241.733 81.3724 239.385 84.0832 236.562 86.2266C233.74 88.37 230.503 89.899 227.059 90.7148C223.615 91.5306 220.039 91.6154 216.561 90.9648L216.569 90.9121C214.389 90.5894 212.715 88.7027 212.715 86.4229C212.715 83.9165 214.738 81.8849 217.233 81.8848C217.731 81.8848 218.21 81.9668 218.658 82.1162C220.761 82.4498 222.91 82.3694 224.984 81.8779C227.205 81.3518 229.292 80.3663 231.118 78.9844C232.932 77.6024 234.445 75.854 235.555 73.8516C236.664 71.8491 237.345 69.6363 237.555 67.3545C237.764 65.0725 237.498 62.7714 236.772 60.5986C236.047 58.4261 234.878 56.4295 233.341 54.7363C231.803 53.0431 229.931 51.6901 227.844 50.7646C225.756 49.8392 223.499 49.3613 221.218 49.3613V40.2822Z"
          fill="url(#paint3_linear_4179_67325)"
        />
        <path
          d="M221.168 28.1797C229.498 28.1798 237.586 30.9899 244.136 36.1592C250.686 41.3285 255.318 48.5572 257.288 56.6865C259.258 64.8159 258.453 73.3744 255.002 80.9893C251.606 88.4812 245.842 94.63 238.611 98.4893C237.885 98.9887 237.008 99.2822 236.062 99.2822C233.566 99.2821 231.543 97.2496 231.543 94.7432C231.543 92.9368 232.594 91.3769 234.115 90.6465L234.08 90.5781C239.67 87.6719 244.127 82.9633 246.735 77.209C249.343 71.4548 249.952 64.9877 248.463 58.8447C246.974 52.7016 243.474 47.2384 238.524 43.332C233.575 39.4258 227.463 37.3028 221.168 37.3027V28.1797Z"
          fill="url(#paint4_linear_4179_67325)"
        />
        <path
          d="M221.164 16.0771C228.748 16.0771 236.23 17.8259 243.034 21.1885C249.839 24.551 255.784 29.4375 260.411 35.4717C265.039 41.5059 268.226 48.5268 269.726 55.9932C271.226 63.4596 270.999 71.1725 269.063 78.5371L269.042 78.5312C268.523 80.4629 266.767 81.8848 264.68 81.8848C262.184 81.8846 260.161 79.8521 260.161 77.3457C260.161 76.715 260.289 76.1141 260.521 75.5684C261.948 69.7428 262.079 63.6697 260.896 57.7832C259.669 51.6743 257.062 45.9294 253.275 40.9922C249.489 36.0551 244.625 32.0568 239.058 29.3057C233.49 26.5546 227.369 25.124 221.164 25.124V16.0771Z"
          fill="url(#paint5_linear_4179_67325)"
        />
        <rect x="-22" y="16.0769" width="245.442" height="9.07692" fill="#A7EDFF" />
        <rect x="-22" y="28.1794" width="245.442" height="9.07692" fill="#FEF39B" />
        <rect x="-22" y="40.282" width="245.442" height="9.07692" fill="#FFCEA1" />
        <rect x="-22" y="52.3845" width="245.442" height="9.07692" fill="#FFC2E4" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4179_67325"
          x1="220.5"
          y1="0"
          x2="220.5"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette.background.level1} />
          <stop offset="1" stopColor={palette.background.level2} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4179_67325"
          x1="220.5"
          y1="0"
          x2="220.5"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette.background.level1} />
          <stop offset="1" stopColor={palette.background.level2} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4179_67325"
          x1="214.776"
          y1="74.3661"
          x2="220.07"
          y2="59.7947"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF36A4" />
          <stop offset="1" stopColor="#FFC2E4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4179_67325"
          x1="221.92"
          y1="47.5087"
          x2="221.212"
          y2="88.7522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCEA1" />
          <stop offset="1" stopColor="#FF8400" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4179_67325"
          x1="234.864"
          y1="97.6376"
          x2="225.948"
          y2="36.0192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FECF12" />
          <stop offset="1" stopColor="#FEF39B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4179_67325"
          x1="223.342"
          y1="24.6437"
          x2="199.01"
          y2="107.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7EDFF" />
          <stop offset="1" stopColor="#02C4F5" />
        </linearGradient>
        <clipPath id="clip0_4179_67325">
          <rect width="441" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Education4dpSnailGraphic;
